module.exports = __webpack_public_path__ + "static/tesla-powerwall-540w-66cb583db28cb37aa4ee942a1cd66be3.jpg";